export const EXTERNAL_LINKS = {
  TALES_FB: "https://www.facebook.com/TalesComicsAndGames/",
  TALES_IG: "https://www.instagram.com/tales_comicsandgames/",
  TALES_TT: "https://www.tiktok.com/@talesmontagnana",
  TALES_KOFI: "https://ko-fi.com/diregolaarte",
};
